var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"animated-figures"},_vm._l(([1,2,3,4,5,6,7,8,9,10]),function(i){return _c('li',{key:i})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }